import { Form as FormType } from '@crm/api'
import {
  DateElement,
  DateTimeElement,
  InputElement,
  NumberElement,
  RadioElement,
  SelectElement,
  TextareaElement,
  UploadElement
} from '@crm/components'
import { ElementType, TaskFormElement } from '@crm/types'
import { $Object } from '@crm/utils'

const ElementComponents = {
  [ElementType.INPUT]: InputElement,
  [ElementType.NUMBER]: NumberElement,
  [ElementType.RADIO]: RadioElement,
  [ElementType.DATE]: DateElement,
  [ElementType.DATETIME]: DateTimeElement,
  [ElementType.SELECT]: SelectElement,
  [ElementType.FILE]: UploadElement,
  [ElementType.TEXTAREA]: TextareaElement
}

type Props = {
  elements?: FormType[] | TaskFormElement[]
  visibility: $Object
}

export const DynamicFormComponent = ({ elements, visibility }: Props) =>
  elements?.map((element, key) => {
    if (visibility[element.name]) {
      const FormComponent =
        ElementComponents[element.type as keyof typeof ElementComponents]

      if (FormComponent) {
        return <FormComponent element={element as TaskFormElement} key={key} />
      }

      console.log(`This form element is not implemented:`, element)

      return <div key={element.name}></div>
    }

    return null
  })
